<app-banner
  *ngIf="isOpen"
  class="small-body"
  [option]="option"
  [action]="action"
  (clickAction)="setClickAction()"
></app-banner>
